// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zg4N","rootNoMargin":"styles_rootNoMargin__3sAuX"};